import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "back",
  "use": "back-usage",
  "viewBox": "0 0 18 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 15\" id=\"back\"><path fill=\"#555353\" fill-rule=\"evenodd\" d=\"M7 4V0L0 7l7 7V9.9c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol